import { ApplicationUserModel, TenantUserModel } from "@/libs/Api";

export enum AuthAction {
    SignIn = 'SIGN_IN',
    SignInResponse = 'SIGN_IN_RESPONSE',
    SignInResponseFailed = 'SIGN_IN_RESPONSE_FAILED',
    SignUp = 'SING_UP',
    SignUpResponse = 'SING_UP_RESPONSE',
    SignOut = 'SIGN_OUT',
    ActivateAccount = 'ACTIVATE_ACCOUNT',
    ActivateAccountResponse = 'ACTIVATE_ACCOUNT_RESPONSE',
    ResetPassword = 'RESET_PASSWORD',
    ResetPasswordResponse = 'RESET_PASSWORD_RESPONSE',
    ResetSetNewPassword = 'RESET_SET_NEW_PASSWORD',
    SetPassword = 'SET_PASSWORD',
    SetPasswordResponse = 'SET_PASSWORD_RESPONSE',
    SetNewPassword = 'SET_NEW_PASSWORD',
    SetTenant = 'SET_TENANT',
    SetTenantUser = 'SET_TENANT_USER',
    ResetSetNewPasswordResponse = 'RESET_SET_NEW_PASSWORD_RESPONSE',
    UserInfo = 'USER_INFO',
    SetUser = 'SET_USER'
}

export enum AuthGetter {
    GetIsLoggedIn = 'GET_IS_LOGGED_IN',
    GetUserInfo = 'GET_USER_INFO',
    GetTenant = 'GET_TENANT',
    GetTenantUser = 'GET_TENANT_USER',
    GetUser = 'GET_USER'
}

export class AuthState {
    isLoggedIn = false;
    userInfo: any = null;
    tenant: string | null = null;
    tenantUser: TenantUserModel | null = null;
    user: ApplicationUserModel | null = null;
}